import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginAdmin } from '../redux/reducers/adminSlice'; // Import the loginAdmin action
import { useNavigate} from 'react-router-dom';
import { AiOutlineMail, AiOutlineLock } from 'react-icons/ai';
import backgroundImage from '../assets/radio.jpeg';
import logo from '../assets/logo_black.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, adminData } = useSelector((state) => state.admin);

  const handleLogin = (e) => {
    console.log("Login");
    e.preventDefault();
    dispatch(loginAdmin({ userName: email, password }));
  };

  useEffect(() => {
  if (adminData?.acessToken) {
    navigate('/news');
  }
}, [adminData, navigate]);


  // if (adminData) {
  //   // Navigate to the admin dashboard or another page after successful login
  //   navigate('/news');
  // }

  return (
    <div className="flex h-screen">
      <div className="w-1/2 bg-cover bg-center">
        <img src={backgroundImage} alt="Background" className="w-full h-full object-cover" />
      </div>

      <div className="w-1/2 flex items-center justify-center bg-white">
        <div className="w-full max-w-md p-8">
          <div className="flex justify-center mb-6">
            <img src={logo} alt="Radio Surabhi" className="h-16" />
          </div>

          <h2 className="text-center text-3xl font-semibold mb-8">Login</h2>

          {error && <p className="text-red-500 text-center mb-4">{error}</p>}

          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <div className="flex items-center border rounded-full px-4 py-2 bg-gray-100">
                <AiOutlineMail className="h-6 w-6 text-gray-500" />
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="ml-3 w-full outline-none bg-transparent text-gray-700"
                />
              </div>
            </div>

            <div className="mb-6">
              <div className="flex items-center border rounded-full px-4 py-2 bg-gray-100">
                <AiOutlineLock className="h-6 w-6 text-gray-500" />
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="ml-3 w-full outline-none bg-transparent text-gray-700"
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-2 px-4 bg-pink-500 text-white rounded-full font-semibold hover:bg-pink-600 transition duration-300"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
